import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import * as fromStore from 'src/app/store';

export const PaymentsGuard = (): Observable<boolean> => {
  const store = inject(Store<fromStore.State>);

  const checkStore = (): Observable<boolean> =>
    store.select(fromStore.getPaymentsLoaded).pipe(
      tap((loaded) => {
        if (!loaded) {
          store.dispatch(new fromStore.LoadPayments());
        }
      }),
      filter((loaded) => loaded),
      take(1),
    );

  return checkStore().pipe(
    switchMap(() => of(true)),
    catchError(() => of(false)),
  );
};
